export default {
    LOAD_MENU: "MENU::LOAD_MENU",
    CHANGE_SELECT_MENU: "MENU::CHANGE_SELECT_MENU",
    CHANGE_OPEN_KEY_MENU: "MENU::CHANGE_OPEN_KEY_MENU",
}